$(function () {
    if (window.UA.isIE11 === true) {
        $('.content-product-about-right').addClass('is-ie11');
        $('.text-border').addClass('is-ie11-border');
        $('.article-list-title span').addClass('is-ie11-border');
        $('.article-list-small-title span').addClass('is-ie11-border');
        $('.btn').addClass('is-ie11-btn');
        $('.l-footer-link-item a').addClass('is-ie11-btn');
        $('.letters-article-sns a').addClass('is-ie11-btn');
        $('.article-list-category').addClass('is-ie11-btn');
        $('.article-list-small-category').addClass('is-ie11-btn');
        $('.letters-article-category').addClass('is-ie11-btn');
        $('.letters-article-date').addClass('is-ie11-btn');
        $('.contact-form-require').addClass('is-ie11-btn');
        $('.contact-form input').addClass('is-ie11-btn');
        $('.contact-form select').addClass('is-ie11-btn');
    }
});




/*****************
 ** WEBPACK FOOTER
 ** ./src/pc/js/module/browser.js
 ** module id = 1
 ** module chunks = 0
 **/